import {AdicionalDeProduto} from "./AdicionalDeProduto";
import {OpcaoDeAdicionalDeProduto} from "./OpcaoDeAdicionalDeProduto";
import {EnumTipoDeCobrancaDeAdicional} from "../../lib/emun/EnumTipoDeCobrancaDeAdicional";

export class AdicionalDeProdutoMultiplaEscolha extends AdicionalDeProduto {

  constructor(nome: string, obrigatorio: boolean, opcoesDisponiveis: Array<OpcaoDeAdicionalDeProduto>,
              public qtdMinima: number, public qtdMaxima: number, public podeRepetirItem: boolean,
              public tipoDeCobranca: EnumTipoDeCobrancaDeAdicional = EnumTipoDeCobrancaDeAdicional.SOMA,
              entidade: string = 'produto') {
    super(nome, obrigatorio, 'multipla-escolha', opcoesDisponiveis, entidade);
    this.classe = this.tipo + '-' + this.entidade;
  }

  permiteMultiplaEscolha(): boolean {
    return true;
  }

  clone(): AdicionalDeProduto {
    let novo = new AdicionalDeProdutoMultiplaEscolha(this.nome, this.obrigatorio, [],
                  this.qtdMinima, this.qtdMaxima,  this.podeRepetirItem, this.tipoDeCobranca, this.entidade);

    novo.classe = this.classe;
    this.opcoesDisponiveis.forEach( opcao => novo.opcoesDisponiveis.push(opcao.clone()))

    return  novo;
  }

  obtenhaDescricao(): string {
    return `Você pode escolher até ${this.qtdMaxima} adicionais.
*Escolha 1 por vez!*`;
  }

  podeIrParaProximo(qtdeEscolhidos: number): boolean {
    if( !this.obrigatorio ) {
      return true;
    }

    return qtdeEscolhidos >= this.qtdMinima;
  }
}
